//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { isLoading } from 'state/reducers/beneficiary.reducers';
//mui
import { Box } from '@mui/system';
import { Button, Stack } from '@mui/material';
import { FormButton } from 'theme/elements/Buttons';
import { getMobile } from 'state/reducers/ui.reducers';

type footerProps = {
	handleCancel: any;
	handleBack: any;
	ifBack: boolean;
	handleSubmit: any;
	disableSubmit?: boolean;
	labelSubmit?: string;
	labelCancel?: string;
	labelBack?: string;
	disableBack?: boolean;
};

export default function Footer(props: footerProps) {
	const loading: boolean = useAppSelector(isLoading);
	const t = useAppSelector(selectTranslations);
	const isMobile = useAppSelector(getMobile);
	return (
		<Box justifyContent="space-between" display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
			<FormButton>
				<Button
					className={isMobile ? 'singleFormButton' : ''}
					variant="text"
					disabled={loading}
					onClick={() => {
						props.handleCancel();
					}}
				>
					{props.labelCancel || 'Cancel'}
				</Button>
			</FormButton>
			<Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
				{props.ifBack && (
					<FormButton>
						<Button
							variant="outlined"
							className={isMobile ? 'singleFormButton' : ''}
							disabled={props.disableBack || loading}
							onClick={() => {
								props.handleBack();
							}}
						>
							{props.labelBack || 'Back'}
						</Button>
					</FormButton>
				)}
				<FormButton>
					<Button
						onClick={() => props.handleSubmit()}
						className={isMobile ? 'singleFormButton' : ''}
						variant="contained"
						disabled={props.disableSubmit || loading}
					>
						{props.labelSubmit || 'Submit'}
					</Button>
				</FormButton>
			</Stack>
		</Box>
	);
}
